<wiz-vgroup padding="10px" width="100%" height="100%" class="section-container">
  <wiz-hgroup width="100%" height="100%">
    <wiz-vgroup width="100%" height="100%">
      <wiz-hgroup width="100%">
        <wiz-label
        [wizLabel]="'$.widget.configure.data-bank.$'"
        width="100%"
        class="smallTitleLabel"
        ></wiz-label>
        <wiz-icon (click)="hide()" style="cursor: pointer">close</wiz-icon>
      </wiz-hgroup>
      

      <wiz-list
        #ddSteps
        class="shadowed"
        width="100%"
        height="100%"
        [wizLabel]="'$.vision.steps.$'"
        [wizLabelField]="'levelAndLabel'"
        [wizDataProvider]="stepDS">
      </wiz-list>
    </wiz-vgroup>

  </wiz-hgroup>

  <wiz-vgroup width="100%">
    <wiz-hgroup width="100%">
      <wiz-checkbox #cbComputeMode [wizLabel]="'$.compute.mode.$'" *ngIf="isGrid" [wizChecked]='computeMode'></wiz-checkbox>
      <wiz-numeric-input #niPageSize [wizLabel]="'$.compute.pagesize.$'" [visible]="computeMode"
      [wizNumber]="computePageSize"
      nbDecimal=0 
      allowNegative=false
      wizMaxNumber=500></wiz-numeric-input>
    </wiz-hgroup>

    

    <wiz-checkbox #cbTot [wizLabel]="'$.grid.showtotal.$'" *ngIf="isGrid" [wizChecked]='showTotal'></wiz-checkbox>
    <wiz-checkbox #cbSubTot [wizLabel]="'$.grid.showsubtotal.$'" *ngIf="isPivot" [wizChecked]='showSubTotal'></wiz-checkbox>

    <wiz-hgroup width="100%" *ngIf="isPivot" gap="10">
        <wiz-checkbox #cbSubTotMulti *ngIf="isPivot"
        [wizLabel]="'$.grid.showsubtotal.multiple.$'" 
        [wizChecked]='showSubTotalMulti'
        (wizClick)="manageSettings($event)"
        ></wiz-checkbox>
        <wiz-text-input *ngIf="isPivot && isPmdEx"
          #tiPmdExParams
          [wizLabel]="'$.mesure.settings.$'"
          [wizValue]="pmdExParams"
          [wizMaxChars]="250"
          width="100%"
        ></wiz-text-input>
    </wiz-hgroup>
    
  </wiz-vgroup>

  <wiz-hgroup width="100%">
    <wiz-dropdown #ddMaster
    [wizLabel]="'$.widget.master.$'"
    [wizDataProvider]="allAgis"
    [wizLabelField]="'labelAndIdx'"></wiz-dropdown>

    <wiz-checkbox #cbMefe [wizLabel]="'$.widget.slave.strictmode.$'" [visible]="hasMaster" [wizChecked]='emptyToEmpty'></wiz-checkbox>
  </wiz-hgroup>
  

  <wiz-hgroup width="100%" horizontalAlign="end">
    <wiz-button wizLabel="$.common.validate.$" (wizClick)="save()" [wizDisabled]="!validable" width="200px"></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
